import RealtimeStatusContainer from './container/RealtimeStatusContainer'
export default {
  path: '/status',
  component : RealtimeStatusContainer,
}